
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";

import {
    IonButtons,
    IonBackButton,
    IonAccordionGroup,
    IonAccordion,
    IonModal,
    IonGrid,
    IonFooter,
    IonRow,
    IonCol,
    IonContent,
    IonHeader, IonPage, IonTitle, IonToolbar,
    IonApp,
    IonIcon,
    IonLabel,
    IonRouterOutlet,
    IonTabBar,
    IonTabButton,
    IonTabs,
    setupIonicReact,
    IonButton,
    IonRouterContext,
    IonRouteProps,
    IonLoading,
    IonToast,
    IonCard,
    IonFabButton,
    IonInfiniteScroll,
    IonSegment,
    IonSegmentButton,
    IonList,
    IonItem,
    IonText,
    IonFab,
    IonSearchbar,
    IonTextarea,
    IonInfiniteScrollContent,
    IonCheckbox,
    withIonLifeCycle, IonRefresher, IonRefresherContent
} from '@ionic/react';

import { arrowUp, business, barcode, person, podium, closeOutline, search, add, ticketOutline, receiptOutline, personOutline, callOutline, logoWhatsapp, locationOutline, mapOutline } from 'ionicons/icons';
import { DebounceInput } from 'react-debounce-input';
import Moment from 'react-moment';
import moment from 'moment';
import { Capacitor } from '@capacitor/core';

import { getContact, getPermissions, getShoppingCart, getTransactions, getLoginApp, getTransactionPayments } from '../../utils/functions';
import PosActions from '../../actions/PosActions';

const options2 = { style: 'currency', currency: 'USD', useGrouping: false };
const _numberFormat = new Intl.NumberFormat('en-US', options2);
import Select from 'react-select';
import { Printer } from '@bcyesil/capacitor-plugin-printer';

import './ContactList.css';

interface IProps {
    get_: any;
    setData_: any;
    post_: any;
}

interface IState {
    contacts: any;
    pageSize: any;
    pages: any;
    loadmore_data_pagination: any;
    current_count_data: any;
    total_rows: any;
    searchText: any;
    data_login_ari_app: any;

    currencyprimary: any;
    primary_label: any;

    currencysecondary: any;
    secondary_label: any;
    rate: any;
    secondary_operation: any;
    data_velues: any;
    payments: any;
    modalPaymentShow: any;
    cash_register_util: any;
    payment_types_is_secondary: any;
    id_payment: any;
    payment_types_key: any;
    loading: any;
    day_visit: any;
    taxes_impositive: any;
}

class ContactList extends React.Component<IProps, IState> {
    contentRef: React.RefObject<HTMLIonContentElement>;
    ionInfiniteScrollRefData: React.RefObject<HTMLIonInfiniteScrollElement>;

    constructor(props: any) {
        super(props)
        this.contentRef = React.createRef<HTMLIonContentElement>();
        this.ionInfiniteScrollRefData = React.createRef<HTMLIonInfiniteScrollElement>();

        this.state = {
            loadmore_data_pagination: props.loadmore_data_pagination,
            current_count_data: props.current_count_data,
            contacts: props.contacts,
            pageSize: props.pageSize,
            pages: props.pages,
            total_rows: props.total_rows,
            searchText: props.searchText,
            data_login_ari_app: props.data_login_ari_app,

            rate: props.rate,
            currencyprimary: props.currencyprimary,
            primary_label: props.primary_label,
            currencysecondary: props.currencysecondary,
            secondary_label: props.secondary_label,
            secondary_operation: props.secondary_operation,
            data_velues: props.data_velues,
            payments: props.payments,
            modalPaymentShow: props.modalPaymentShow,
            cash_register_util: props.cash_register_util,
            payment_types_is_secondary: props.payment_types_is_secondary,
            id_payment: props.id_payment,
            payment_types_key: props.payment_types_key,
            loading: props.loading,
            day_visit: props.day_visit,
            taxes_impositive: props.taxes_impositive
        }
    }

    async componentDidMount() {

        let data_login_ari_app: any = !getLoginApp() ? [] : getLoginApp();

        let ari_app_transaction_payments = !getTransactionPayments() ? [
            {
                label: 'cash',
                id: 'cash',
                amount: 0,
                secondary: 0,
                transaction_no_2: '',
                note: '',
                is_secondary: 0

            }
        ] : getTransactionPayments();

        ari_app_transaction_payments = ari_app_transaction_payments.length == 0 ? [
            {
                label: 'cash',
                id: 'cash',
                amount: 0,
                secondary: 0,
                transaction_no_2: '',
                note: '',
                is_secondary: 0

            }
        ] : ari_app_transaction_payments;

        this.setState({
            day_visit: 'all',
            loading: false,
            pages: 0,
            pageSize: 10,
            total_rows: 0,
            searchText: '',
            current_count_data: 0,
            loadmore_data_pagination: true,
            data_login_ari_app: data_login_ari_app,
            data_velues: {
                final_total: 0,
                final_total_secondary: 0,
                total_paid: 0,
                total_paid_secondary: 0,
                total_return: 0,
                total_return_secondary: 0,
                total_rest: 0,
                total_rest_secondary: 0,
                contact_id: null,
                contact_name: '',
                contact_num: ''
                //price_group: price_group,
                //selling_price_may_id: selling_price_may_id
            },
            payments: ari_app_transaction_payments ? ari_app_transaction_payments : [
                {
                    label: 'cash',
                    id: 'cash',
                    amount: 0,
                    secondary: 0,
                    transaction_no_2: '',
                    note: ''
                }
            ],
            modalPaymentShow: false,

        });
        setTimeout(this.getDataPaginInit.bind(this), 1000);
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {

        this.setState({
            contacts: nextProps.data.data_pagin && nextProps.data.data_pagin ? nextProps.data.data_pagin : [],
            pages: nextProps.data.contacts && nextProps.data.contacts.pages ? nextProps.data.contacts.pages : 0,
            total_rows: nextProps.data.contacts && nextProps.data.contacts.total_rows ? nextProps.data.contacts.total_rows : 0,
            current_count_data: nextProps.data.data_pagin ? nextProps.data.data_pagin.length : 0,

            rate: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util.rate : 1,
            currencyprimary: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util.currencyprimary : '',
            primary_label: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util.primary_label : 'primary',
            currencysecondary: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util.currencysecondary : '',
            secondary_label: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util.secondary_label : 'secondary',
            secondary_operation: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util.secondary_operation : '*',
            cash_register_util: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util : null,
            taxes_impositive: nextProps.data.data_default && nextProps.data.data_default.taxes_impositive ? nextProps.data.data_default.taxes_impositive : [],

            payment_types_is_secondary: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util.payment_types_is_secondary : [],
            payment_types_key: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util.payment_types_key : [],
            loading: nextProps.data.loading && nextProps.data.loading.isOpen ? nextProps.data.loading.isOpen : false,
        });

        if (nextProps.data.view_active == "customer_dues") {
            if (nextProps.data.refresh_list && !nextProps.data.concat_list) {
                this.buttomup();
                this.setState({
                    pages: 0,
                    pageSize: 10,
                });

                setTimeout(this.getDataPaginInit.bind(this), 1000);
            }
            if (this.ionInfiniteScrollRefData.current) {
                if (nextProps.data.concat_list) {
                    this.ionInfiniteScrollRefData.current.complete();
                }
            }
        }

        if (nextProps.data.response && nextProps.data.response.success && nextProps.data.response.receipt) {

            setTimeout(this.printTransaction.bind(this, nextProps.data.response.receipt), 100);

        }

    }

    printTransaction(html: any) {
        if (Capacitor.isNativePlatform()) {
            Printer.print({ content: html, name: 'lorem-filename', orientation: 'portrait' })
                .then((res: any) => {
                    this.props.setData_({ response: {}, simpleToast: false, loading: { Msg: 'Cargando...', isOpen: false } });

                })
                .catch((err: any) => {

                    this.props.setData_({ response: {}, simpleToast: false, loading: { Msg: 'Cargando...', isOpen: false } });
                });
        } else {
            // Para navegador web
            const printFrame = document.createElement('iframe');
            printFrame.style.position = 'fixed';
            printFrame.style.right = '0';
            printFrame.style.bottom = '0';
            printFrame.style.width = '0';
            printFrame.style.height = '0';
            printFrame.style.border = '0';
            printFrame.srcdoc = html;
            // Insertar el iframe en el div print-area en lugar de document.body
            const printArea = document.getElementById('print-area');
            if (printArea) {
                printArea.appendChild(printFrame);
            } else {
                document.body.appendChild(printFrame);
            }

            printFrame.onload = () => {
                printFrame.contentWindow?.focus();
                printFrame.contentWindow?.print();
                setTimeout(() => {
                    if (printFrame.parentNode === document.body) {
                        document.body.removeChild(printFrame);
                    } else if (printFrame.parentNode) {
                        printFrame.parentNode.removeChild(printFrame);
                    }
                }, 3000);
            };

            this.props.setData_({ response: {}, simpleToast: false });
        }
    }

    getDataPaginInit() {
        if (this.state.total_rows != 0 && this.state.current_count_data == this.state.total_rows && this.state.pages != 0) {
            if (this.ionInfiniteScrollRefData.current) {
                this.ionInfiniteScrollRefData.current.complete();
            }
            return;
        }

        this.props.get_({
            user_id: this.state.data_login_ari_app.id,
            typeOption: 'get_customer_dues',
            search: this.state.searchText,
            pageSize: this.state.pageSize,
            pages: this.state.pages,
            current_count_data: this.state.current_count_data,
            view_active: 'customer_dues',
            day_visit: this.state.day_visit,
        }, "api/get_customer_dues");
    }

    buttomup() {
        if (this.contentRef.current) {
            this.contentRef.current.scrollToTop();
        }
    }

    onChangeForValuesDetailsArrayProductFilter(index: any, e: any) {
        let contacts = this.state.contacts;
        let new_contacts: any = [];
        new_contacts = contacts.map((item: any, i: any) => {
            if ((index) == i) {
                let unpaid_sell_transactions = item.unpaid_sell_transactions.map((transaction: any) => {
                    if (transaction.id == e.transaction_id) {
                        return { ...transaction, checked: e.checked };
                    }
                    return transaction;
                });
                return { ...item, unpaid_sell_transactions: unpaid_sell_transactions };
            } else {
                return item;
            }
        });

        this.setState({
            contacts: new_contacts
        });
        setTimeout(this.ajustTotalsContacts.bind(this), 100);
    }

    ajustTotalsContacts() {
        let contacts = this.state.contacts;
        let new_contacts: any = [];

        new_contacts = contacts.map((item: any, i: any) => {
            let balance_due_paid = 0;

            item.unpaid_sell_transactions.map((transaction: any) => {
                if (transaction.checked) {
                    balance_due_paid += parseFloat(transaction.final_total);
                }
            });

            balance_due_paid = balance_due_paid == 0 ? item.balance_due : balance_due_paid;

            return {
                ...item,
                balance_due_paid: balance_due_paid
            };
        });

        this.setState({
            contacts: new_contacts
        });

    }

    render_contacts(row: any, key: any) {
        let data_permission = getPermissions();
        let transactions = row.unpaid_sell_transactions.map((val: any, key_: any) => {
            return (
                <tr key={key_ + "_transactions"}>
                    <td>
                        <IonCheckbox
                            checked={val.checked}
                            onIonChange={e => this.onChangeForValuesDetailsArrayProductFilter(key, { transaction_id: val.id, checked: e.detail.checked })}
                            name="checked"
                        />
                    </td>
                    <td>{val.invoice_no}</td>
                    <td><Moment format="YYYY-MM-DD">{val.transaction_date}</Moment></td>
                    <td>{_numberFormat.format(parseFloat(val.total_invoice_due)).replace("$", this.state.currencyprimary)}</td>
                </tr>
            );
        });

        return (
            <IonCard key={key + "_contact"}>
                <IonItem lines="none">
                    <IonIcon slot="start" color='#28bb50' icon={personOutline} />
                    <IonLabel>
                        <h2>{row.name}</h2>
                    </IonLabel>
                    <IonButton slot="end" color="success" onClick={this.openmodalPayment.bind(this, row)}>
                        <IonIcon slot="icon-only" icon={receiptOutline} />
                        Pagar
                    </IonButton>
                </IonItem>
                <IonAccordionGroup>
                    <IonAccordion value="facturas">
                        <IonItem slot="header" color="light">
                            <IonLabel>Total Deuda: {_numberFormat.format(parseFloat(row.balance_due)).replace("$", this.state.currencyprimary)}</IonLabel>
                        </IonItem>
                        <div className="ion-padding" slot="content">
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr>
                                        <th style={{ width: '5%' }}></th>
                                        <th style={{ width: '35%', textAlign: 'left' }}>Factura</th>
                                        <th style={{ width: '35%', textAlign: 'left' }}>Fecha</th>
                                        <th style={{ width: '25%', textAlign: 'left' }}>Monto</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {transactions}
                                </tbody>
                            </table>
                        </div>
                    </IonAccordion>
                </IonAccordionGroup>
            </IonCard>
        );
    }

    closemodalPayment() {

        this.setState({
            modalPaymentShow: false
        });

    }

    removedPayment(index: any) {
        let payments: any = [];
        this.state.payments.map((item: any, i: any) => {
            if (i != index) {
                payments.push(item);
            }
        });
        this.setState({
            payments: payments
        });

        setTimeout(this.refreshTotalShipping.bind(this), 100);

    }

    handleChangeDefault(event: any) {

        this.setState({
            ...this.state,
            [event.target.name]: event.target.value
        });

        setTimeout(this.refreshTotalShipping.bind(this), 100);

    }

    refreshTotalShipping() {

        let data_velues = this.state.data_velues;

        let total_due_taxes: any = 0;
        let counter_checked = 0;
        data_velues.unpaid_sell_transactions.map((transaction: any) => {
            if (transaction.checked) {
                counter_checked++;
                total_due_taxes += parseFloat(transaction.grand_total) - (parseFloat(transaction.quick_payment_amount) || 0);
            }
        });

        let payments = [...(this.state.payments ?? [])];
        let secondary_operation = this.state.secondary_operation;
        let rate = this.state.rate;

        let total_paid = 0;
        let total_paid_secondary = 0;


        if (payments && payments.length > 0) {
            if (total_due_taxes > 0) {
                payments[0].amount = total_due_taxes > 0 ? total_due_taxes : payments[0].amount;
                payments[0].secondary = secondary_operation == "/" ? parseFloat(payments[0].amount) / parseFloat(rate) : parseFloat(payments[0].amount) * parseFloat(rate);
                payments[0].amount = parseFloat(payments[0].amount).toFixed(2);
                payments[0].secondary = parseFloat(payments[0].secondary).toFixed(2);
            } else {
                payments && payments.length > 0 && payments.map((payment: any) => {
                    total_paid += parseFloat(payment.amount);
                    total_paid_secondary += parseFloat(payment.secondary);
                });

            }
        }



        data_velues['final_total'] = total_due_taxes > 0 ? total_due_taxes : parseFloat(data_velues.final_total);
        data_velues['final_total_secondary'] = secondary_operation == "/" ? parseFloat(data_velues['final_total']) / parseFloat(rate) : parseFloat(data_velues['final_total']) * parseFloat(rate);
        data_velues['total_paid'] = total_paid;
        data_velues['total_paid_secondary'] = total_paid_secondary;

        let total_rest = parseFloat(data_velues['final_total']) - parseFloat(data_velues['total_paid']);
        let total_rest_secondary = parseFloat(data_velues['final_total_secondary']) - parseFloat(data_velues['total_paid_secondary']);
        if (total_rest <= 0) {
            total_rest = 0;
            total_rest_secondary = 0;
        }

        let total_return = parseFloat(data_velues['total_paid']) - parseFloat(data_velues['final_total']);
        let total_return_secondary = parseFloat(data_velues['total_paid_secondary']) - parseFloat(data_velues['final_total_secondary']);

        if (total_return <= 0) {
            total_return = 0;
            total_return_secondary = 0;
        }


        data_velues['total_paid'] = total_paid;
        data_velues['total_paid_secondary'] = total_paid_secondary;

        data_velues['total_return'] = total_return;
        data_velues['total_return_secondary'] = total_return_secondary;

        data_velues['total_rest'] = total_rest;
        data_velues['total_rest_secondary'] = total_rest_secondary;
        data_velues['counter_checked'] = counter_checked;

        this.setState({
            data_velues: data_velues,
            payments: payments
        });


    }

    handleFocus(event: any) {
        event.target.select();
    }

    onChangeDetailsArrayPayment(index: any, e: any) {

        let payment = this.state.payments;
        let rate = this.state.rate;
        let secondary_operation = this.state.secondary_operation;
        let newArr: any = [];
        if (e.target.name == 'amount') {

            let secondary: any = secondary_operation == "/" ? parseFloat(e.target.value) / parseFloat(rate) : parseFloat(e.target.value) * parseFloat(rate);
            let amount: any = parseFloat(e.target.value);

            newArr = payment.map((item: any, i: any) => {
                if ((index) == i) {
                    return {
                        ...item,
                        'amount': amount,
                        'secondary': secondary,
                    };
                } else {
                    return item;
                }
            });

        } else if (e.target.name == 'secondary') {

            let amount: any = secondary_operation == "/" ? parseFloat(e.target.value) * parseFloat(rate) : parseFloat(e.target.value) / parseFloat(rate);
            let secondary: any = e.target.value;

            newArr = payment.map((item: any, i: any) => {
                if ((index) == i) {
                    return {
                        ...item,
                        'amount': amount,
                        'secondary': secondary,
                    };
                } else {
                    return item;
                }
            });

        } else {
            newArr = payment.map((item: any, i: any) => {
                if ((index) == i) {
                    return {
                        ...item,
                        [e.target.name]: e.target.value,
                    };
                } else {
                    return item;
                }
            });
        }

        let new_payment = newArr;

        this.setState({
            payments: new_payment
        });

        setTimeout(this.refreshTotalShipping.bind(this), 100);
    }

    onChangeImpositiveTaxCheck(transactionIndex: number, taxIndex: number, checked: boolean) {
        let sum_grand_total_temp = 0;
        this.setState((prevState: IState) => {
            const unpaidSellTransactions = (prevState.data_velues?.unpaid_sell_transactions ?? []).map((transaction: any, currentTransactionIndex: number) => {
                if (currentTransactionIndex !== transactionIndex) {
                    return transaction;
                }
                const arrayTaxesImpositives = (transaction.array_taxes_impositives ?? []).map((tax: any, currentTaxIndex: number) => {
                    if (currentTaxIndex !== taxIndex) {
                        return tax;
                    }

                    if (checked) {
                        let temp_tax_amount = parseFloat(transaction.total_before_tax) * parseFloat(tax.tasa) / 100;

                        return {
                            ...tax,
                            check: checked,
                            amount: temp_tax_amount
                        };
                    } else {
                        return {
                            ...tax,
                            check: checked,
                            amount: 0
                        }
                    }

                });

                let grand_total_temp = parseFloat(transaction.total_invoice_due);
                arrayTaxesImpositives.forEach((tax: any) => {
                    grand_total_temp -= parseFloat(tax.amount || 0);
                });

                sum_grand_total_temp += grand_total_temp;

                return {
                    ...transaction,
                    array_taxes_impositives: arrayTaxesImpositives,
                    grand_total: grand_total_temp,
                };
            });

            return {
                data_velues: {
                    ...prevState.data_velues,
                    unpaid_sell_transactions: unpaidSellTransactions,
                }
            } as Pick<IState, 'data_velues'>;
        });

        setTimeout(this.refreshTotalShipping.bind(this), 100);
    }

    onChangeImpositiveProntoPago(transactionIndex: number, taxIndex: number, value: any) {
        this.setState((prevState: IState) => {
            const unpaidSellTransactions = (prevState.data_velues?.unpaid_sell_transactions ?? []).map((transaction: any, currentTransactionIndex: number) => {
                if (currentTransactionIndex !== transactionIndex) {
                    return transaction;
                }
                let amount_pronto_pago = parseFloat(value) / 100 * parseFloat(transaction.total_before_tax);
                transaction.quick_payment = value;
                transaction.quick_payment_amount = amount_pronto_pago;

                return {
                    ...transaction,
                };
            });
            return {
                data_velues: {
                    ...prevState.data_velues,
                    unpaid_sell_transactions: unpaidSellTransactions,
                }
            } as Pick<IState, 'data_velues'>;

        });
        setTimeout(this.refreshTotalShipping.bind(this), 100);
    }


    addPayment() {
        let id_payment = this.state.id_payment;
        let payments = this.state.payments;

        let grand_total_due = 0;
        this.state.data_velues.unpaid_sell_transactions.map((transaction: any) => {
            if (transaction.checked) {
                grand_total_due += parseFloat(transaction.grand_total) - (parseFloat(transaction.quick_payment_amount) || 0);
            }
        });

        if (grand_total_due == 0) {
            grand_total_due = this.state.data_velues.contact_balance_due;
        }


        if (id_payment) {
            //verificar si ya existe el pago agregado
            let payments_filter = payments.filter((item_filter: any) => item_filter.id == id_payment);
            if (payments_filter.length == 0) {
                let payment_types = (this.state.cash_register_util && this.state.cash_register_util.payment_types && this.state.cash_register_util.payment_types) ?? [];
                if (payment_types.length > 0) {
                    let filter_payment_types = payment_types.filter((item_filter: any) => item_filter.id == id_payment);
                    if (filter_payment_types.length > 0) {
                        console.log('grand_total_due', grand_total_due);
                        payments.push(
                            {
                                label: filter_payment_types[0].label,
                                amount: grand_total_due > 0 ? grand_total_due : 0,
                                secondary: 0,
                                transaction_no_2: '',
                                note: '',
                                id: filter_payment_types[0].id,
                                payment_id: filter_payment_types[0].payment_id,
                                is_secondary: this.state.payment_types_is_secondary[filter_payment_types[0].id] ?? 0
                            }
                        );
                        this.setState({
                            payments: payments
                        });
                    }
                }
            } else {
                if (payments_filter[0].label == 'cash') {
                    let payment_types = (this.state.cash_register_util && this.state.cash_register_util.payment_types && this.state.cash_register_util.payment_types) ?? [];
                    if (payment_types.length > 0) {
                        let filter_payment_types = payment_types.filter((item_filter: any) => item_filter.id == 'cash');
                        if (filter_payment_types.length > 0) {

                            this.props.setData_({
                                response: { Msg: "ya esta agregado este metodo de pago: " + filter_payment_types[0].label },
                                simpleToast: true
                            });
                        }
                    }
                } else {
                    this.props.setData_({
                        response: { Msg: "ya esta agregado este metodo de pago: " + payments_filter[0].label },
                        simpleToast: true
                    });
                }
            }


        }
        setTimeout(this.refreshTotalShipping.bind(this), 100);

    }

    openmodalPayment(row: any, e: any) {
        /*
        data_velues: {
                final_total: 0,
                final_total_secondary: 0,
                total_paid: 0,
                total_paid_secondary: 0,
                total_return: 0,
                total_return_secondary: 0,
                total_rest: 0,
                total_rest_secondary: 0,
                contact_id: null,
                contact_name: '',
                contact_num: ''
            },
        */
        let data_velues = this.state.data_velues;
        let secondary_operation = this.state.secondary_operation;
        let rate = this.state.rate;

        data_velues['contact_id'] = row.id;
        data_velues['contact_name'] = row.name + " " + (row.supplier_business_name ? row.supplier_business_name : '');
        data_velues['contact_num'] = row.contact_id ? row.contact_id : '';
        data_velues['contact_balance_due'] = row.balance_due;
        let total_final_total: any = 0;
        row.unpaid_sell_transactions.map((val: any, key_: any) => {
            if (val.checked) {
                total_final_total += parseFloat(val.total_invoice_due);
            }
        });

        if (total_final_total == 0) {
            total_final_total = row.balance_due;
        }

        data_velues['final_total'] = total_final_total;
        let secondary: any = secondary_operation == "/" ? parseFloat(total_final_total) / parseFloat(rate) : parseFloat(total_final_total) * parseFloat(rate);
        data_velues['final_total_secondary'] = secondary;
        data_velues['total_paid'] = 0;
        data_velues['total_paid_secondary'] = 0;
        data_velues['total_return'] = 0;
        data_velues['total_return_secondary'] = 0;
        data_velues['total_rest'] = total_final_total;
        data_velues['total_rest_secondary'] = secondary;
        data_velues['unpaid_sell_transactions'] = row.unpaid_sell_transactions ? row.unpaid_sell_transactions : [];

        this.setState({
            data_velues: data_velues,
            modalPaymentShow: true,
            id_payment: null,
            payments: [

            ]
        });
    }

    sendOrder() {


        let data_velues = this.state.data_velues;
        let payments = this.state.payments;

        let data_send = {
            user_id: this.state.data_login_ari_app.id,
            contact_id: data_velues.contact_id,
            contact_balance_due: data_velues.contact_balance_due,
            counter_checked: data_velues.counter_checked,
            final_total: data_velues.final_total,
            final_total_secondary: data_velues.final_total_secondary,
            total_paid: data_velues.total_paid,
            total_paid_secondary: data_velues.total_paid_secondary,
            total_return: data_velues.total_return,
            total_return_secondary: data_velues.total_return_secondary,
            total_rest: data_velues.total_rest,
            total_rest_secondary: data_velues.total_rest_secondary,
            unpaid_sell_transactions: data_velues.unpaid_sell_transactions,
            payments: payments,
            transaction_date: moment().format("YYYY-MM-DD HH:mm:ss"),
            view_active: 'customer_dues',
            typeOption: 'save_payment_dues',

        }

        this.props.post_(data_send, (data_velues.counter_checked == 0 ? 'api/save_payment_dues_all' :'api/save_payment_dues'));
        this.setState({
            modalPaymentShow: false,
        });
    }

    handleRefresh(event: any) {
        this.setState({
            pages: 0,
            pageSize: 10,
        });
        setTimeout(() => {
            event.detail.complete();
        }, 2000);
        setTimeout(this.getDataPaginInit.bind(this), 1000);
    }

    setSearchText(e: any) {
        const value = e.target.value;
        this.setState({
            searchText: value.toLowerCase(),
            pages: 0,
            pageSize: 10,
            loadmore_data_pagination: true
        });
        setTimeout(this.getDataPaginInit.bind(this), 100);
    }

    changeDay(day_visit: any) {
        this.setState({
            day_visit: day_visit,
            pages: 0,
            pageSize: 10,
            loadmore_data_pagination: true
        });
        setTimeout(this.getDataPaginInit.bind(this), 100);
    }

    render() {
        const { searchText, day_visit, payment_types_is_secondary, primary_label, contacts, currencyprimary, modalPaymentShow, data_velues, currencysecondary, cash_register_util, payments, id_payment, taxes_impositive } = this.state;
        let data_render_contacts = [];

        if (contacts && contacts.length > 0) {
            data_render_contacts = [];
            data_render_contacts = contacts.map((val: any, key: any) =>
                this.render_contacts(val, key)
            );
        };

        return (
            <IonPage>
                <IonRefresher slot="fixed" onIonRefresh={(e) => this.handleRefresh(e)}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>
                <IonRow className='no-print'>
                    <IonCol col-12 size='12' class='div_horizontal_buttom_segment_pos_contact'>
                        <IonSegment value={day_visit} scrollable={true}>
                            <IonSegmentButton
                                value={'all'}
                                onClick={() =>
                                    this.changeDay('all')
                                }
                            >
                                <IonLabel>Todos</IonLabel>
                            </IonSegmentButton>

                            <IonSegmentButton
                                value={1}
                                onClick={() =>
                                    this.changeDay(1)
                                }
                            >
                                <IonLabel>Lunes</IonLabel>
                            </IonSegmentButton>

                            <IonSegmentButton
                                value={2}
                                onClick={() =>
                                    this.changeDay(2)
                                }
                            >
                                <IonLabel>Martes</IonLabel>
                            </IonSegmentButton>
                            <IonSegmentButton
                                value={3}
                                onClick={() =>
                                    this.changeDay(3)
                                }
                            >
                                <IonLabel>Miercoles</IonLabel>
                            </IonSegmentButton>
                            <IonSegmentButton
                                value={4}
                                onClick={() =>
                                    this.changeDay(4)
                                }
                            >
                                <IonLabel>Jueves</IonLabel>
                            </IonSegmentButton>
                            <IonSegmentButton
                                value={5}
                                onClick={() =>
                                    this.changeDay(5)
                                }
                            >
                                <IonLabel>Viernes</IonLabel>
                            </IonSegmentButton>
                            <IonSegmentButton
                                value={6}
                                onClick={() =>
                                    this.changeDay(6)
                                }
                            >
                                <IonLabel>Sabado</IonLabel>
                            </IonSegmentButton>
                            <IonSegmentButton
                                value={0}
                                onClick={() =>
                                    this.changeDay(0)
                                }
                            >
                                <IonLabel>Domingo</IonLabel>
                            </IonSegmentButton>


                        </IonSegment>
                    </IonCol>
                    <IonCol col-12 size='12' style={{ textAlign: "center" }}>
                        <div style={{ display: "none" }}>
                            <IonSearchbar onIonChange={e => this.setSearchText(e)} value={searchText}></IonSearchbar>
                        </div>

                    </IonCol>
                    <IonCol col-12 size='12' class='divflex'>
                        <IonIcon icon={search} className='iconseach'></IonIcon>

                        <DebounceInput
                            className='btn_search'
                            placeholder={'Buscar cliente por Nombre/Código'}
                            minLength={2}
                            debounceTimeout={2000}
                            value={searchText}
                            onChange={e => this.setSearchText(e)} />
                    </IonCol>
                    <IonCol size="12">
                        {data_render_contacts}
                    </IonCol>
                    <IonInfiniteScroll threshold="50px" ref={this.ionInfiniteScrollRefData}
                        onIonInfinite={(event) => {
                            this.getDataPaginInit();
                        }}
                    >
                        <IonInfiniteScrollContent loadingText="Cargando mas datos..." loadingSpinner="bubbles"></IonInfiniteScrollContent>
                    </IonInfiniteScroll>
                    <IonModal
                        onWillDismiss={e => this.closemodalPayment()}
                        isOpen={modalPaymentShow}
                        trigger="open-modal"
                    >
                        <IonHeader>
                            <IonToolbar>
                                <IonTitle style={{ textAling: "center" }}>Pago multiple</IonTitle>
                                <IonButton slot="end" style={{ textAling: "center", marginRight: '10px' }} onClick={(ev) => this.closemodalPayment()}>
                                    <IonIcon icon={closeOutline}></IonIcon>
                                </IonButton>
                            </IonToolbar>
                        </IonHeader>
                        <IonContent className="ion-padding">
                            <IonRow>
                                <IonCol col-12 size='12'>
                                    {
                                        data_velues && data_velues.unpaid_sell_transactions && data_velues.unpaid_sell_transactions.length > 0 ?
                                            <div className="data-table-container">
                                                <table style={{ width: '100%', borderCollapse: 'collapse' }} className="data-table">
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: '15%', textAlign: 'left', whiteSpace: 'nowrap' }}>Factura</th>
                                                            <th style={{ width: '20%', textAlign: 'left', whiteSpace: 'nowrap' }}>Sub&nbsp;Total</th>
                                                            <th style={{ width: '15%', textAlign: 'left', whiteSpace: 'nowrap' }}>Total&nbsp;Impuesto</th>
                                                            <th style={{ width: '15%', textAlign: 'left', whiteSpace: 'nowrap' }}>Total&nbsp;Factura</th>
                                                            <th style={{ width: '15%', textAlign: 'left', whiteSpace: 'nowrap' }}>Total Deuda</th>
                                                            <th style={{ width: '15%', textAlign: 'left', whiteSpace: 'nowrap' }}>Pronto&nbsp;Pago</th>
                                                            {
                                                                taxes_impositive ?
                                                                    taxes_impositive.map((tax: any, index_tax: number) => (
                                                                        <th key={index_tax} style={{ width: '15%', textAlign: 'left', whiteSpace: 'nowrap' }}>{tax.name}  ({tax.amount}%)</th>
                                                                    ))
                                                                    : null
                                                            }
                                                            <th style={{ width: '15%', textAlign: 'left', whiteSpace: 'nowrap' }}>Gran&nbsp;Total</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {data_velues.unpaid_sell_transactions.map((transaction: any, index: number) => (
                                                            transaction.checked ?
                                                                <tr key={index}>
                                                                    <td style={{ textAlign: 'left' }}>{transaction.invoice_no}</td>
                                                                    <td style={{ width: '35%', textAlign: 'right' }}>{_numberFormat.format(parseFloat(transaction.total_before_tax)).replace("$", '')}</td>
                                                                    <td style={{ textAlign: 'right' }}>{_numberFormat.format(parseFloat(transaction.tax_amount)).replace("$", '')}</td>
                                                                    <td style={{ textAlign: 'right' }}>{_numberFormat.format(parseFloat(transaction.final_total)).replace("$", '')}</td>
                                                                    <td style={{ textAlign: 'right' }}>{_numberFormat.format(parseFloat(transaction.total_invoice_due)).replace("$", '')}</td>
                                                                    <td style={{ textAlign: 'right' }}>
                                                                        <input
                                                                            autoComplete="off"
                                                                            onFocus={this.handleFocus}
                                                                            type="number"
                                                                            className='inputform input_quantity style_input'
                                                                            defaultValue={_numberFormat.format(parseFloat(transaction.quick_payment)).replace("$", "")}
                                                                            min="0"
                                                                            onChange={e => this.onChangeImpositiveProntoPago(index, 0, e.target.value)}
                                                                            name="amount" />
                                                                    </td>
                                                                    {
                                                                        transaction.array_taxes_impositives && transaction.array_taxes_impositives.length > 0 ?
                                                                            transaction.array_taxes_impositives.map((tax: any, index_tax: number) => (
                                                                                <td key={index_tax} style={{ width: '30%', textAlign: 'left' }}>
                                                                                    <IonCheckbox
                                                                                        checked={tax.check || false}
                                                                                        onIonChange={e => this.onChangeImpositiveTaxCheck(index, index_tax, e.detail.checked)}
                                                                                    />
                                                                                    {tax.amount}
                                                                                </td>
                                                                            ))
                                                                            : null
                                                                    }
                                                                    <td style={{ textAlign: 'right' }}>{_numberFormat.format(transaction.grand_total - (transaction.quick_payment_amount ||
                                                                        (transaction.quick_payment ? ((transaction.quick_payment / 100) * transaction.grand_total) : 0)
                                                                    )).replace("$", '')}</td>

                                                                </tr>
                                                                : null
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                            : null

                                    }
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol col-12 size='12'>
                                    <strong>Cliente: {(data_velues && data_velues.contact_name) ?? ''} ({(data_velues && data_velues.contact_num) ?? ''})</strong>
                                </IonCol>
                                <IonCol col-12 size='12'>
                                    Total a Pagar :&nbsp;
                                    <span style={{ color: '#007bff', fontWeight: 'bold' }}>
                                        {data_velues && data_velues.final_total ? _numberFormat.format(data_velues.final_total).replace("$", currencyprimary) : _numberFormat.format(0).replace("$", currencyprimary)}
                                    </span>
                                    &nbsp;-&nbsp;
                                    <span style={{ color: '#007bff', fontWeight: 'bold' }}>
                                        {data_velues && data_velues.final_total_secondary ? _numberFormat.format(data_velues.final_total_secondary).replace("$", currencysecondary) : _numberFormat.format(0).replace("$", currencysecondary)}
                                    </span>
                                </IonCol>
                                <IonCol col-12 size='12'>
                                    Saldo:&nbsp;
                                    <span style={{ color: '#dc3545', fontWeight: 'bold' }}>
                                        {data_velues && data_velues.total_rest ? _numberFormat.format(data_velues.total_rest).replace("$", currencyprimary) : _numberFormat.format(0).replace("$", currencyprimary)}
                                    </span>
                                    &nbsp;-&nbsp;
                                    <span style={{ color: '#dc3545', fontWeight: 'bold' }}>
                                        {data_velues && data_velues.total_rest_secondary ? _numberFormat.format(data_velues.total_rest_secondary).replace("$", currencysecondary) : _numberFormat.format(0).replace("$", currencysecondary)}
                                    </span>
                                </IonCol>
                                <IonCol col-12 size='12'>
                                    Pago total:&nbsp;
                                    <span style={{ color: '#28a745', fontWeight: 'bold' }}>
                                        {data_velues && data_velues.total_paid ? _numberFormat.format(data_velues.total_paid).replace("$", currencyprimary) : _numberFormat.format(0).replace("$", currencyprimary)}
                                    </span>
                                    &nbsp;-&nbsp;
                                    <span style={{ color: '#28a745', fontWeight: 'bold' }}>
                                        {data_velues && data_velues.total_paid_secondary ? _numberFormat.format(data_velues.total_paid_secondary).replace("$", currencysecondary) : _numberFormat.format(0).replace("$", currencysecondary)}
                                    </span>
                                </IonCol>
                                <IonCol col-12 size='12'>
                                    Cambio:&nbsp;
                                    <span style={{ color: '#ffc107', fontWeight: 'bold' }}>
                                        {data_velues && data_velues.total_return ? _numberFormat.format(data_velues.total_return).replace("$", currencyprimary) : _numberFormat.format(0).replace("$", currencyprimary)}
                                    </span>
                                    &nbsp;-&nbsp;
                                    <span style={{ color: '#ffc107', fontWeight: 'bold' }}>
                                        {data_velues && data_velues.total_return_secondary ? _numberFormat.format(data_velues.total_return_secondary).replace("$", currencysecondary) : _numberFormat.format(0).replace("$", currencysecondary)}
                                    </span>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol col-10 size='10'>
                                    {
                                        cash_register_util && cash_register_util.payment_types && cash_register_util.payment_types.length > 0 ?
                                            <Select
                                                onChange={(e: any) => this.handleChangeDefault({ target: { name: 'id_payment', value: e.value } })}
                                                placeholder="Metodos de Pago"
                                                name='id_payment'
                                                menuPortalTarget={document.querySelector('body')}
                                                isSearchable={false}
                                                options={
                                                    cash_register_util.payment_types.map((option: any) => (
                                                        { label: option.label, value: option.id }
                                                    ))
                                                }
                                                styles={{
                                                    menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                                }}
                                                defaultValue={id_payment ?
                                                    cash_register_util && cash_register_util.payment_types && cash_register_util.payment_types.length > 0 ?
                                                        { label: cash_register_util.payment_types.filter((item: any) => item.id == id_payment)[0].name, value: cash_register_util.payment_types.filter((item: any) => item.id == id_payment)[0].id }
                                                        : null
                                                    : null
                                                }
                                            /> : null
                                    }
                                </IonCol>
                                {
                                    payments && payments.length == 0 ?
                                        <IonCol col-2 size='2'>
                                            <IonButton style={{ textAling: "center", marginRight: '10px' }} onClick={(ev) => this.addPayment()}>
                                                <IonIcon icon={add}></IonIcon>
                                            </IonButton>
                                        </IonCol> : null
                                }
                            </IonRow>
                            <IonRow>
                                {
                                    payments && payments.length > 0 && payments.map((val: any, key: any) =>
                                        <>
                                            <IonCol col-12 size='12' key={key} className='card_line'>

                                                <IonRow>

                                                    <IonCol col-10 size='10' style={{ textAlign: 'left' }} >
                                                        <strong className=''> {val.label == 'cash' ? primary_label : val.label} </strong>   <br />
                                                    </IonCol>

                                                    <IonCol col-2 size='2' style={{ textAlign: 'right' }} >
                                                        <IonLabel color="primary" onClick={(ev) => this.removedPayment(key)} ><strong>X</strong></IonLabel>
                                                    </IonCol>
                                                    {
                                                        val.is_secondary == 0 ?
                                                            <IonCol col-6 size='6'>
                                                                {currencyprimary} <br />
                                                                <input
                                                                    autoComplete="off"
                                                                    disabled={data_velues.counter_checked && data_velues.counter_checked > 0 ? true : false}
                                                                    onFocus={this.handleFocus}
                                                                    type="number"
                                                                    className='inputform input_quantity style_input'
                                                                    value={val.amount ?? 0}
                                                                    min="0"
                                                                    onChange={e => this.onChangeDetailsArrayPayment(key, e)}
                                                                    name="amount" />
                                                            </IonCol>
                                                            : null
                                                    }

                                                    {
                                                        payment_types_is_secondary && payment_types_is_secondary[val.id] && payment_types_is_secondary[val.id] == 1 ?
                                                            <IonCol col-6 size='6'>
                                                                {currencysecondary} <br />
                                                                <input autoComplete="off"
                                                                    onFocus={this.handleFocus}
                                                                    type="number"
                                                                    className='inputform input_quantity style_input'
                                                                    disabled={data_velues.counter_checked && data_velues.counter_checked > 0 ? true : false}
                                                                    value={val.secondary ?? 0}

                                                                    min="0"
                                                                    onChange={e => this.onChangeDetailsArrayPayment(key, e)}
                                                                    name="secondary" />
                                                            </IonCol> : null
                                                    }

                                                    <IonCol col-12 size='12'>
                                                        <label>Transacción No.: </label>

                                                        <input className='inputform' type="text" placeholder="N°" onChange={e => this.onChangeDetailsArrayPayment(key, e)} value={(val.transaction_no_2) ?? ""}
                                                            name="transaction_no_2" />

                                                    </IonCol>
                                                    <IonCol col-12 size='12'>
                                                        <label>Nota de pago: </label>

                                                        <textarea className='inputform' rows={3} placeholder="Nota de Pago" onChange={e => this.onChangeDetailsArrayPayment(key, e)} value={(val && val.note) ?? ""}
                                                            name="note" />
                                                    </IonCol>

                                                </IonRow>
                                            </IonCol>

                                        </>
                                    )
                                }
                                <IonCol col-12 size='12' style={{ textAlign: "center", display: 'inline-block' }}>
                                    <IonButton size="default" color="success" onClick={() => this.sendOrder()}>
                                        <strong>Pagar</strong>
                                    </IonButton>
                                </IonCol>
                            </IonRow>
                        </IonContent>
                    </IonModal>
                </IonRow>
            </IonPage>
        );
    };
}

const mapStateToProps = (state: any) => {
    return {
        data: state.data,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        get_: (fields: any, controller: string) => dispatch(PosActions.get_(fields, controller)),
        setData_: (data: any, name: string) => dispatch(PosActions.setData(data, name)),
        post_: (fields: any, controller: string) => dispatch(PosActions.post_(fields, controller))
    }
};

export default withIonLifeCycle(connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(ContactList));

